import { addSearchParams } from '../../lib/url';
import { PaymentFrame } from './payment-frame';
export { PaymentFrame };
export var paymentForm = function (apiHost, options) {
    var _a = options.queryParams, queryParams = _a === void 0 ? {} : _a;
    if (options.cardId) {
        queryParams.card_id = options.cardId;
    }
    if (options.sbpLinkTarget) {
        queryParams.sbp_link_target = options.sbpLinkTarget;
    }
    if (options.canUseApplePay) {
        queryParams.can_use_apple_pay = String(options.canUseApplePay);
    }
    var url = addSearchParams(options.url, queryParams);
    var frame = new PaymentFrame(url, {
        apiHost: apiHost,
        canUseApplePay: options.canUseApplePay,
        onDomMount: options.onDomMount,
        onDomUnmount: options.onDomUnmount
    });
    return Promise.resolve(frame);
};
